import React, { useEffect, useState } from 'react';
import { getAffiliate } from '../../config';
import { apiAffiliateLogout, apiAffiliateReport } from '../../api/api-affiliate';
import { FontAwesomeIcon } from '../common';
import moment from 'moment';

const AffiliateBookings = ({ onClose }) => {
    const [affiliateDetails, setAffiliateDetails] = useState(null);
    const [date, setDate] = useState();
    const [report, setReport] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const loadData = async () => {
            setLoading(true);
            const report = await apiAffiliateReport(date);
            setReport(report?.reportRows || []);
            setLoading(false);
        };

        if (date) {
            loadData();
        }
    }, [date]);

    useEffect(() => {
        const affiliate = getAffiliate();

        if (!affiliate || !affiliate.viewOwnBookings) {
            apiAffiliateLogout();
        } else {
            setAffiliateDetails(affiliate);
            const now = new Date();
            const first = new Date(now.getFullYear(), now.getMonth(), 1);
            setDate(first);
        }
    }, []);

    if (!affiliateDetails) {
        return null;
    }

    return (
        <div>
            <div className="flex gap-x-4 items-center">
                <div className="px-2 py-1 whitespace-nowrap flex items-center gap-x-2">
                    <div>Tour:</div>
                    <div className="font-bold">{moment(date).format('MMMM YYYY')}</div>
                </div>
                <FontAwesomeIcon icon="arrow-left" className="cursor-pointer" onClick={() => setDate(new Date(date.getFullYear(), date.getMonth() - 1, 1))} />
                <FontAwesomeIcon icon="arrow-right" className="cursor-pointer" onClick={() => setDate(new Date(date.getFullYear(), date.getMonth() + 1, 1))} />
            </div>
            {loading ? (
                <div className="text-center">
                    <i className="fad fa-spinner fa-pulse fa-lg"></i>
                </div>
            ) : (
                <table className="table-auto w-full">
                    <thead>
                        <tr>
                            <th className="px-2 py-1 bg-gray-100">Booked</th>
                            <th className="px-2 py-1 bg-gray-100">Tour Date</th>
                            <th className="px-2 py-1 bg-gray-100">Tour Time</th>
                            <th className="px-2 py-1 bg-gray-100">Name</th>
                            <th className="px-2 py-1 bg-gray-100 text-right">Total Price</th>
                            <th className="px-2 py-1 bg-gray-100">Code</th>
                        </tr>
                    </thead>
                    <tbody>
                        {report.length === 0 && (
                            <tr>
                                <td colSpan={7} className="px-2 py-1 text-center">
                                    No bookings found
                                </td>
                            </tr>
                        )}
                        {report.map((booking, idx) => (
                            <tr key={idx} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                                <td className="px-2 py-1">{moment(new Date(booking.createdDate)).format('Do MMM YYYY')}</td>
                                <td className="px-2 py-1">{moment(new Date(booking.tourDate)).format('Do MMM YYYY')}</td>
                                <td className="px-2 py-1">{booking.tourTime}</td>
                                <td className="px-2 py-1">{booking.name}</td>
                                <td className="px-2 py-1 text-right">
                                    {new Intl.NumberFormat('en-GB', {
                                        style: 'currency',
                                        currency: 'GBP',
                                    }).format(booking.pricePaid)}
                                </td>
                                <td className="px-2 py-1">{booking.affiliateCode}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
            <div className="button-bar mt-4">
                <button type="button" onClick={onClose} className="btn-secondary">
                    Close
                </button>
            </div>
        </div>
    );
};

export default AffiliateBookings;
